import { LifemapLog, LifemapType, PlCalendarEvent, plEventsColor } from '@shared/services/lifemap/lifemap.service';
import { getRandomInt } from '@app/utils/general';

export const getMockLifeMapLogsSimplifiedForUnitTest = (): LifemapLog[] => {
  return [
    {
      id: 0,
      timeslotId: 0,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      id: 1,
      timeslotId: 1,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      id: 2,
      timeslotId: 2,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
      updatedAt: '2023-11-14 17:30:00',
    },
  ];
};

export const getMockLifeMapLogsResponseFromBackEndSimplifiedForUnitTest = (): LifemapLog[] => {
  return [
    {
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
      answers: undefined,
      id: 0,
      timeslotId: 0,
      type: LifemapType.sleep,
    },
    {
      activityName: 'Meeting',
      answers: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
      id: 1,
      timeslotId: 1,
      type: LifemapType.work,
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
      answers: undefined,
      id: 191,
      timeslotId: 191,
      type: LifemapType.sleep,
    },
  ];
};

export const getMockCalendarEventsSimplifiedForUnitTest = (): PlCalendarEvent[] => {
  return [
    {
      id: '0-1',
      color: plEventsColor[LifemapType.sleep].eventColor,
      title: 'Sleep',
      start: new Date('2024-01-01T00:00:00.000'),
      end: new Date('2024-01-01T00:30:00.000'),

      meta: {
        cssClassForBorder: plEventsColor[LifemapType.sleep].cssClassForBorder,
        isSelected: false,
        type: LifemapType.sleep,
        updatedAt: '2023-11-14 17:30:00',
      },
    },
    {
      id: '1-2',
      title: 'Meeting',
      start: new Date('2024-01-01T00:30:00.000'),
      end: new Date('2024-01-01T01:00:00.000'),
      color: plEventsColor[LifemapType.work].eventColor,
      meta: {
        cssClassForBorder: plEventsColor[LifemapType.work].cssClassForBorder,
        answers: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
        isSelected: false,
        type: LifemapType.work,
        updatedAt: '2023-11-14 17:30:00',
      },
    },
    {
      id: 'addNewEntry-gr4cxmrxyp',
      title: 'Create new entry',
      start: new Date('2024-01-01T01:00:00.000'),
      end: new Date('2024-01-04T23:30:00.000'),
      color: plEventsColor[LifemapType.addNewEntry].eventColor,
      meta: {
        cssClassForBorder: plEventsColor[LifemapType.addNewEntry].cssClassForBorder,
        isSelected: false,
        type: LifemapType.addNewEntry,
        updatedAt: '2023-11-14 17:30:00',
      },
    },
    {
      id: 'lifeMapLog-njs0m0xqel',
      title: 'Sleep',
      start: new Date('2024-01-04T23:00:00.000'),
      end: new Date('2024-01-04T23:59:59.999'),
      color: plEventsColor[LifemapType.sleep].eventColor,
      meta: {
        cssClassForBorder: plEventsColor[LifemapType.sleep].cssClassForBorder,
        isSelected: false,
        type: LifemapType.sleep,
        updatedAt: '2023-11-14 17:30:00',
      },
    },
  ];
};

export const getMockPlCalendarEventsForUnitTestingEventResizing = (): PlCalendarEvent[] => {
  return [
    {
      id: '0-2',
      title: 'Sleep',
      start: new Date('2024-01-01T00:00:00.000'),
      end: new Date('2024-01-01T01:00:00.000'),
      color: plEventsColor[LifemapType.sleep].eventColor,
      meta: {
        cssClassForBorder: plEventsColor[LifemapType.sleep].cssClassForBorder,
        isSelected: false,
        type: LifemapType.sleep,
        updatedAt: '2023-11-14 17:30:00',
      },
    },
    {
      id: '2-4',
      title: 'Meeting',
      start: new Date('2024-01-01T01:00:00.000'),
      end: new Date('2024-01-01T02:00:00.000'),
      color: plEventsColor[LifemapType.work].eventColor,
      meta: {
        cssClassForBorder: plEventsColor[LifemapType.work].cssClassForBorder,
        isSelected: false,
        type: LifemapType.work,
        answers: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
        updatedAt: '2023-11-14 17:30:00',
      },
    },
    {
      id: 'gr4cxmrxyp',
      title: 'Create new',
      start: new Date('2024-01-01T02:00:00.000'),
      end: new Date('2024-01-01T23:59:59.000'),
      color: plEventsColor[LifemapType.addNewEntry].eventColor,
      meta: {
        cssClassForBorder: plEventsColor[LifemapType.addNewEntry].cssClassForBorder,
        isSelected: false,
        type: LifemapType.addNewEntry,
        updatedAt: '2023-11-14 17:30:00',
      },
    },
    {
      id: 'njs0m0xqel',
      title: 'Sleep',
      start: new Date('2024-01-02T00:00:00.000'),
      end: new Date('2024-01-02T08:00:00.000'),
      color: plEventsColor[LifemapType.sleep].eventColor,
      meta: {
        cssClassForBorder: plEventsColor[LifemapType.sleep].cssClassForBorder,
        isSelected: false,
        type: LifemapType.sleep,
        updatedAt: '2023-11-14 17:30:00',
      },
    },
    {
      id: 'fsgfjhjkm',
      title: 'Blocked',
      start: new Date('2024-01-02T08:00:00.000'),
      end: new Date('2024-01-04T22:00:00.000'),
      color: plEventsColor[LifemapType.addNewEntry].eventColor,
      meta: {
        cssClassForBorder: plEventsColor[LifemapType.addNewEntry].cssClassForBorder,
        isSelected: false,
        type: LifemapType.addNewEntry,
        updatedAt: '2023-11-14 17:30:00',
      },
    },
    {
      id: 'njs0m0xqel',
      title: 'Sleep',
      start: new Date('2024-01-04T22:00:00.000'),
      end: new Date('2024-01-04T23:59:59.999'),
      color: plEventsColor[LifemapType.sleep].eventColor,
      meta: {
        cssClassForBorder: plEventsColor[LifemapType.sleep].cssClassForBorder,
        isSelected: false,
        type: LifemapType.sleep,
        updatedAt: '2023-11-14 17:30:00',
      },
    },
  ];
};

export const getMockLifeMapLogs = (): LifemapLog[] => {
  return [
    {
      id: 1,
      timeslotId: 0,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      id: 2,
      timeslotId: 1,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      id: 3,
      timeslotId: 2,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 3,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 4,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 5,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 6,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 7,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 8,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 9,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 10,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 11,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 12,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 13,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 14,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 15,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 16,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 17,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 18,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 19,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 20,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 21,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 22,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 23,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 24,
      type: LifemapType.nonWork,
      activityName: 'LUNCH',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 25,
      type: LifemapType.nonWork,
      activityName: 'LUNCH',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 26,
      type: LifemapType.nonWork,
      activityName: 'LUNCH',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 27,
      type: LifemapType.nonWork,
      activityName: 'LUNCH',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 28,
      type: LifemapType.work,
      activityName: "NEW WEBSITE extremelyLongTextToTestIfIt'sworkingWell",
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 29,
      type: LifemapType.work,
      activityName: 'NEW WEBSITE',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 30,
      type: LifemapType.work,
      activityName: 'NEW WEBSITE',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 31,
      type: LifemapType.work,
      activityName: 'NEW WEBSITE',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 32,
      type: LifemapType.work,
      activityName: 'NEW WEBSITE',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 33,
      type: LifemapType.work,
      activityName: 'NEW WEBSITE',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 34,
      type: LifemapType.work,
      activityName: 'NEW WEBSITE',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 35,
      type: LifemapType.work,
      activityName: 'NEW WEBSITE',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 36,
      type: LifemapType.work,
      activityName: "NEW WEBSITE extremelyLongTextToTestIfIt'sworkingWell",
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 37,
      type: LifemapType.work,
      activityName: "NEW WEBSITE extremelyLongTextToTestIfIt'sworkingWell",
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 38,
      type: LifemapType.work,
      activityName: "NEW WEBSITE extremelyLongTextToTestIfIt'sworkingWell",
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 39,
      type: LifemapType.work,
      activityName: "NEW WEBSITE extremelyLongTextToTestIfIt'sworkingWell",
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 40,
      type: LifemapType.nonWork,
      activityName: 'Football',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 41,
      type: LifemapType.nonWork,
      activityName: 'Football',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 42,
      type: LifemapType.nonWork,
      activityName: 'Football',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 43,
      type: LifemapType.nonWork,
      activityName: 'Football',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 44,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 45,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 46,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 47,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 48,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 49,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 50,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 51,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 52,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 53,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 54,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 55,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 56,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 57,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 58,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 59,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 60,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 61,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 92,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 93,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 94,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 95,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 96,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 97,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 98,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 99,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 100,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 101,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 102,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 103,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 104,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 105,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 106,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 107,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 108,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 109,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 140,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 141,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 142,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 143,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 144,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 145,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 146,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 147,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 148,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 149,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 150,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 151,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 152,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 153,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 154,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 155,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 156,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 157,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 188,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 189,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 190,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
    {
      timeslotId: 191,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      updatedAt: '2023-11-14 17:30:00',
    },
  ];
};

export const mockBackEndResponseToStoreLifeMapLogs = (lifemapLogsToSave: LifemapLog[]): LifemapLog[] => {
  return lifemapLogsToSave
    .filter((log: LifemapLog): boolean => {
      return log.type !== null;
    })
    .map((log: LifemapLog): LifemapLog => {
      if (log.id === undefined) {
        return {
          ...log,
          id: getRandomInt(10, 100000),
        };
      }
      return log;
    });
};

export const getMockLifemapLogBugUserNotCOmpleteLifemap = (): LifemapLog[] => {
  return [
    {
      id: 69195,
      timeslotId: 4,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69196,
      timeslotId: 5,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69197,
      timeslotId: 6,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69198,
      timeslotId: 7,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69199,
      timeslotId: 8,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69200,
      timeslotId: 9,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69201,
      timeslotId: 10,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69202,
      timeslotId: 11,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69203,
      timeslotId: 12,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69204,
      timeslotId: 13,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69205,
      timeslotId: 46,
      type: LifemapType.nonWork,
      activityName: 'Personal Time',
      answers: [6, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69206,
      timeslotId: 47,
      type: LifemapType.nonWork,
      activityName: 'Personal Time',
      answers: [6, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69207,
      timeslotId: 48,
      type: LifemapType.nonWork,
      activityName: 'Personal Time',
      answers: [6, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69208,
      timeslotId: 49,
      type: LifemapType.nonWork,
      activityName: 'Personal Time',
      answers: [6, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69209,
      timeslotId: 50,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69210,
      timeslotId: 51,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69211,
      timeslotId: 52,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69212,
      timeslotId: 53,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69213,
      timeslotId: 54,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69214,
      timeslotId: 55,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69215,
      timeslotId: 56,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69216,
      timeslotId: 57,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69217,
      timeslotId: 58,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69218,
      timeslotId: 59,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69219,
      timeslotId: 60,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69220,
      timeslotId: 61,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69221,
      timeslotId: 94,
      type: LifemapType.nonWork,
      activityName: 'Gym',
      answers: [6, 5, 5, 5, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-09 03:30:50',
    },
    {
      id: 69222,
      timeslotId: 95,
      type: LifemapType.nonWork,
      activityName: 'Read',
      answers: [5, 5, 3, 1, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-09 03:30:50',
    },
    {
      id: 69223,
      timeslotId: 96,
      type: LifemapType.nonWork,
      activityName: 'Read',
      answers: [5, 5, 3, 1, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-09 03:30:50',
    },
    {
      id: 69224,
      timeslotId: 97,
      type: LifemapType.work,
      activityName: 'Slack',
      answers: [5, 3, 3, 1, 3, 4, 5, 5, 5, 5],
      updatedAt: '2024-07-09 03:30:50',
    },
    {
      id: 69225,
      timeslotId: 98,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69226,
      timeslotId: 99,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69227,
      timeslotId: 100,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69228,
      timeslotId: 101,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69229,
      timeslotId: 102,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69230,
      timeslotId: 103,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69231,
      timeslotId: 104,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69232,
      timeslotId: 105,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69233,
      timeslotId: 106,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69234,
      timeslotId: 107,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69235,
      timeslotId: 108,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69236,
      timeslotId: 109,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69241,
      timeslotId: 146,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69242,
      timeslotId: 147,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69243,
      timeslotId: 148,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69244,
      timeslotId: 149,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69245,
      timeslotId: 150,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69246,
      timeslotId: 151,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69247,
      timeslotId: 152,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69248,
      timeslotId: 153,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69249,
      timeslotId: 154,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69250,
      timeslotId: 155,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69251,
      timeslotId: 156,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69252,
      timeslotId: 157,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-05 19:05:26',
    },
    {
      id: 69259,
      timeslotId: 18,
      type: LifemapType.work,
      activityName: '1:1',
      answers: [4, 4, 3, 1, 5, 5, 4, 5, 4, 4],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69260,
      timeslotId: 19,
      type: LifemapType.work,
      activityName: '1:1',
      answers: [4, 4, 3, 1, 5, 5, 4, 5, 4, 4],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69261,
      timeslotId: 20,
      type: LifemapType.work,
      activityName: 'Training',
      answers: [2, 3, 3, 2, 3, 3, 3, 3, 3, 3],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69262,
      timeslotId: 21,
      type: LifemapType.work,
      activityName: 'Training',
      answers: [2, 3, 3, 2, 3, 3, 3, 3, 3, 3],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69263,
      timeslotId: 22,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [5, 3, 3, 3, 3, 3, 3, 5, 4, 4],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69264,
      timeslotId: 23,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [5, 3, 3, 3, 3, 3, 3, 5, 4, 4],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69265,
      timeslotId: 24,
      type: LifemapType.nonWork,
      activityName: 'Dentist',
      answers: [1, 1, 1, 1, 1, 1, 1, 6, 1, 1],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69266,
      timeslotId: 25,
      type: LifemapType.nonWork,
      activityName: 'Dentist',
      answers: [1, 1, 1, 1, 1, 1, 1, 6, 1, 1],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69267,
      timeslotId: 26,
      type: LifemapType.nonWork,
      activityName: 'Dentist',
      answers: [1, 1, 1, 1, 1, 1, 1, 6, 1, 1],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69268,
      timeslotId: 27,
      type: LifemapType.nonWork,
      activityName: 'Dentist',
      answers: [1, 1, 1, 1, 1, 1, 1, 6, 1, 1],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69269,
      timeslotId: 28,
      type: LifemapType.work,
      activityName: 'Meeting (Talent Review)',
      answers: [5, 4, 3, 1, 3, 5, 5, 5, 4, 4],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69270,
      timeslotId: 29,
      type: LifemapType.work,
      activityName: 'Meeting (Talent Review)',
      answers: [5, 4, 3, 1, 3, 5, 5, 5, 4, 4],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69271,
      timeslotId: 30,
      type: LifemapType.work,
      activityName: 'Meeting (Talent Review)',
      answers: [5, 4, 3, 1, 3, 5, 5, 5, 4, 4],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69272,
      timeslotId: 31,
      type: LifemapType.work,
      activityName: 'Meeting (Talent Review)',
      answers: [5, 4, 3, 1, 3, 5, 5, 5, 4, 4],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69273,
      timeslotId: 32,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 1, 3, 4, 4, 4, 4, 4],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69274,
      timeslotId: 33,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 1, 3, 4, 4, 4, 4, 4],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69275,
      timeslotId: 34,
      type: LifemapType.nonWork,
      activityName: 'Gym',
      answers: [5, 5, 5, 5, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69276,
      timeslotId: 35,
      type: LifemapType.nonWork,
      activityName: 'Gym',
      answers: [5, 5, 5, 5, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69277,
      timeslotId: 36,
      type: LifemapType.nonWork,
      activityName: 'Read',
      answers: [5, 5, 3, 3, 3, 4, 6, 6, 5, 5],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69278,
      timeslotId: 37,
      type: LifemapType.nonWork,
      activityName: 'Read',
      answers: [5, 5, 3, 3, 3, 4, 6, 6, 5, 5],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69279,
      timeslotId: 38,
      type: LifemapType.nonWork,
      activityName: 'Personal Time',
      answers: [6, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:15:18',
    },
    {
      id: 69280,
      timeslotId: 39,
      type: LifemapType.nonWork,
      activityName: 'Personal Time',
      answers: [6, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:15:18',
    },
    {
      id: 69281,
      timeslotId: 40,
      type: LifemapType.nonWork,
      activityName: 'Personal Time',
      answers: [6, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:15:18',
    },
    {
      id: 69282,
      timeslotId: 41,
      type: LifemapType.nonWork,
      activityName: 'Personal Time',
      answers: [6, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:15:18',
    },
    {
      id: 69283,
      timeslotId: 42,
      type: LifemapType.nonWork,
      activityName: 'Personal Time',
      answers: [6, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:15:18',
    },
    {
      id: 69284,
      timeslotId: 43,
      type: LifemapType.nonWork,
      activityName: 'Personal Time',
      answers: [6, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:15:18',
    },
    {
      id: 69285,
      timeslotId: 44,
      type: LifemapType.nonWork,
      activityName: 'Personal Time',
      answers: [6, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:15:18',
    },
    {
      id: 69286,
      timeslotId: 45,
      type: LifemapType.nonWork,
      activityName: 'Personal Time',
      answers: [6, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:15:18',
    },
    {
      id: 69287,
      timeslotId: 62,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69288,
      timeslotId: 63,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69289,
      timeslotId: 64,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69290,
      timeslotId: 65,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69291,
      timeslotId: 66,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 1, 3, 4, 6, 6, 4, 4],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69292,
      timeslotId: 67,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 1, 3, 4, 6, 6, 4, 4],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69293,
      timeslotId: 68,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [4, 4, 3, 1, 3, 4, 4, 5, 4, 4],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69294,
      timeslotId: 69,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69295,
      timeslotId: 70,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69296,
      timeslotId: 71,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69297,
      timeslotId: 72,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69298,
      timeslotId: 73,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69299,
      timeslotId: 74,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69300,
      timeslotId: 75,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69301,
      timeslotId: 76,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69302,
      timeslotId: 77,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69303,
      timeslotId: 78,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69304,
      timeslotId: 79,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69305,
      timeslotId: 80,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69306,
      timeslotId: 81,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69307,
      timeslotId: 82,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69308,
      timeslotId: 83,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69309,
      timeslotId: 84,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69310,
      timeslotId: 85,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69311,
      timeslotId: 86,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69312,
      timeslotId: 87,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69313,
      timeslotId: 88,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-05 19:17:09',
    },
    {
      id: 69314,
      timeslotId: 89,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69315,
      timeslotId: 90,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-09 03:30:49',
    },
    {
      id: 69316,
      timeslotId: 91,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-09 03:30:50',
    },
    {
      id: 69317,
      timeslotId: 92,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 2, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-09 03:30:50',
    },
    {
      id: 69318,
      timeslotId: 93,
      type: LifemapType.nonWork,
      activityName: 'Gym',
      answers: [6, 5, 5, 5, 3, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-09 03:30:50',
    },
    {
      id: 70534,
      timeslotId: 110,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:30:50',
    },
    {
      id: 70535,
      timeslotId: 111,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:30:50',
    },
    {
      id: 71914,
      timeslotId: 112,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:30:50',
    },
    {
      id: 71915,
      timeslotId: 113,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:30:50',
    },
    {
      id: 71916,
      timeslotId: 114,
      type: LifemapType.work,
      activityName: 'Miro Monday',
      answers: [6, 4, 3, 1, 3, 3, 6, 6, 3, 3],
      updatedAt: '2024-07-09 03:30:50',
    },
    {
      id: 71917,
      timeslotId: 115,
      type: LifemapType.work,
      activityName: 'Miro Monday',
      answers: [6, 4, 3, 1, 3, 3, 6, 6, 3, 3],
      updatedAt: '2024-07-09 03:30:50',
    },
    {
      id: 71918,
      timeslotId: 116,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [3, 4, 3, 1, 3, 5, 5, 5, 4, 4],
      updatedAt: '2024-07-09 03:30:50',
    },
    {
      id: 71919,
      timeslotId: 117,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [3, 4, 3, 1, 3, 5, 5, 5, 4, 4],
      updatedAt: '2024-07-09 03:30:50',
    },
    {
      id: 71920,
      timeslotId: 158,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:30:50',
    },
    {
      id: 71921,
      timeslotId: 159,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:30:50',
    },
    {
      id: 71922,
      timeslotId: 160,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:30:50',
    },
    {
      id: 71923,
      timeslotId: 161,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:30:50',
    },
    {
      id: 71926,
      timeslotId: 0,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:31:16',
    },
    {
      id: 71927,
      timeslotId: 1,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:31:16',
    },
    {
      id: 71928,
      timeslotId: 2,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:31:21',
    },
    {
      id: 71929,
      timeslotId: 3,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:31:21',
    },
    {
      id: 71930,
      timeslotId: 118,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [4, 4, 3, 2, 3, 3, 4, 5, 4, 4],
      updatedAt: '2024-07-09 03:31:52',
    },
    {
      id: 71931,
      timeslotId: 119,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [4, 4, 3, 2, 3, 3, 4, 5, 4, 4],
      updatedAt: '2024-07-09 03:31:52',
    },
    {
      id: 71932,
      timeslotId: 120,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [4, 4, 3, 2, 3, 3, 4, 5, 4, 4],
      updatedAt: '2024-07-09 03:31:52',
    },
    {
      id: 71933,
      timeslotId: 121,
      type: LifemapType.work,
      activityName: 'Travel',
      answers: [6, 2, 2, 2, 2, 2, 2, 6, 3, 1],
      updatedAt: '2024-07-10 10:53:57',
    },
    {
      id: 71934,
      timeslotId: 122,
      type: LifemapType.work,
      activityName: 'Travel',
      answers: [6, 2, 2, 2, 2, 2, 2, 6, 3, 1],
      updatedAt: '2024-07-10 10:53:57',
    },
    {
      id: 71935,
      timeslotId: 123,
      type: LifemapType.work,
      activityName: 'Travel',
      answers: [6, 2, 2, 2, 2, 2, 2, 6, 3, 1],
      updatedAt: '2024-07-10 10:53:57',
    },
    {
      id: 71936,
      timeslotId: 124,
      type: LifemapType.work,
      activityName: 'Travel',
      answers: [6, 2, 2, 2, 2, 2, 2, 6, 3, 1],
      updatedAt: '2024-07-10 10:53:57',
    },
    {
      id: 71937,
      timeslotId: 125,
      type: LifemapType.work,
      activityName: 'Travel',
      answers: [6, 2, 2, 2, 2, 2, 2, 6, 3, 1],
      updatedAt: '2024-07-10 10:53:57',
    },
    {
      id: 71938,
      timeslotId: 126,
      type: LifemapType.work,
      activityName: 'Travel',
      answers: [6, 2, 2, 2, 2, 2, 2, 6, 3, 1],
      updatedAt: '2024-07-10 10:53:57',
    },
    {
      id: 71939,
      timeslotId: 127,
      type: LifemapType.work,
      activityName: 'Travel',
      answers: [6, 2, 2, 2, 2, 2, 2, 6, 3, 1],
      updatedAt: '2024-07-10 10:53:57',
    },
    {
      id: 71940,
      timeslotId: 128,
      type: LifemapType.work,
      activityName: 'Travel',
      answers: [6, 2, 2, 2, 2, 2, 2, 6, 3, 1],
      updatedAt: '2024-07-10 10:53:57',
    },
    {
      id: 71941,
      timeslotId: 129,
      type: LifemapType.work,
      activityName: 'Travel',
      answers: [6, 2, 2, 2, 2, 2, 2, 6, 3, 1],
      updatedAt: '2024-07-10 10:53:57',
    },
    {
      id: 71942,
      timeslotId: 130,
      type: LifemapType.work,
      activityName: 'Travel',
      answers: [6, 2, 2, 2, 2, 2, 2, 6, 3, 1],
      updatedAt: '2024-07-10 10:53:57',
    },
    {
      id: 71943,
      timeslotId: 131,
      type: LifemapType.work,
      activityName: 'Travel',
      answers: [6, 2, 2, 2, 2, 2, 2, 6, 3, 1],
      updatedAt: '2024-07-10 10:53:57',
    },
    {
      id: 71944,
      timeslotId: 132,
      type: LifemapType.work,
      activityName: 'Travel',
      answers: [6, 2, 2, 2, 2, 2, 2, 6, 3, 1],
      updatedAt: '2024-07-10 10:53:57',
    },
    {
      id: 71945,
      timeslotId: 133,
      type: LifemapType.work,
      activityName: 'Travel',
      answers: [6, 2, 2, 2, 2, 2, 2, 6, 3, 1],
      updatedAt: '2024-07-10 10:53:57',
    },
    {
      id: 71946,
      timeslotId: 134,
      type: LifemapType.work,
      activityName: 'Travel',
      answers: [6, 2, 2, 2, 2, 2, 2, 6, 3, 1],
      updatedAt: '2024-07-10 10:53:57',
    },
    {
      id: 71947,
      timeslotId: 135,
      type: LifemapType.work,
      activityName: 'Travel',
      answers: [6, 2, 2, 2, 2, 2, 2, 6, 3, 1],
      updatedAt: '2024-07-10 10:53:57',
    },
    {
      id: 71948,
      timeslotId: 136,
      type: LifemapType.work,
      activityName: 'Catch Up',
      answers: [5, 4, 3, 2, 4, 3, 6, 6, 4, 4],
      updatedAt: '2024-07-09 03:33:33',
    },
    {
      id: 71949,
      timeslotId: 137,
      type: LifemapType.work,
      activityName: 'Catch Up',
      answers: [5, 4, 3, 2, 4, 3, 6, 6, 4, 4],
      updatedAt: '2024-07-09 03:33:33',
    },
    {
      id: 71950,
      timeslotId: 138,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:33:45',
    },
    {
      id: 71951,
      timeslotId: 139,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:33:45',
    },
    {
      id: 71952,
      timeslotId: 140,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:33:45',
    },
    {
      id: 71953,
      timeslotId: 141,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:33:45',
    },
    {
      id: 71954,
      timeslotId: 142,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:33:45',
    },
    {
      id: 71955,
      timeslotId: 143,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 03:33:45',
    },
    {
      id: 73161,
      timeslotId: 144,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 14:13:36',
    },
    {
      id: 73162,
      timeslotId: 145,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2024-07-09 14:13:36',
    },
    {
      id: 73163,
      timeslotId: 162,
      type: LifemapType.work,
      activityName: '1:1',
      answers: [5, 4, 3, 1, 3, 4, 4, 5, 4, 4],
      updatedAt: '2024-07-09 14:15:57',
    },
    {
      id: 73164,
      timeslotId: 163,
      type: LifemapType.work,
      activityName: '1:1',
      answers: [5, 5, 4, 1, 3, 5, 5, 5, 5, 5],
      updatedAt: '2024-07-09 14:15:57',
    },
    {
      id: 73165,
      timeslotId: 164,
      type: LifemapType.work,
      activityName: '1:1',
      answers: [5, 5, 4, 1, 3, 5, 5, 5, 5, 5],
      updatedAt: '2024-07-09 14:15:57',
    },
    {
      id: 73166,
      timeslotId: 165,
      type: LifemapType.work,
      activityName: 'GTM Bootcamp',
      answers: [3, 4, 3, 1, 4, 4, 5, 5, 5, 5],
      updatedAt: '2024-07-09 14:16:42',
    },
    {
      id: 73167,
      timeslotId: 166,
      type: LifemapType.work,
      activityName: 'GTM Bootcamp',
      answers: [3, 4, 3, 1, 4, 4, 5, 5, 5, 5],
      updatedAt: '2024-07-09 14:16:42',
    },
    {
      id: 73168,
      timeslotId: 167,
      type: LifemapType.work,
      activityName: 'GTM Bootcamp',
      answers: [3, 4, 3, 1, 4, 4, 5, 5, 5, 5],
      updatedAt: '2024-07-09 14:16:42',
    },
    {
      id: 73169,
      timeslotId: 168,
      type: LifemapType.work,
      activityName: 'GTM Bootcamp',
      answers: [3, 4, 3, 1, 4, 4, 5, 5, 5, 5],
      updatedAt: '2024-07-09 14:16:42',
    },
    {
      id: 73170,
      timeslotId: 169,
      type: LifemapType.work,
      activityName: 'GTM Bootcamp',
      answers: [3, 4, 3, 1, 4, 4, 5, 5, 5, 5],
      updatedAt: '2024-07-09 14:16:42',
    },
    {
      id: 73171,
      timeslotId: 170,
      type: LifemapType.work,
      activityName: 'GTM Bootcamp',
      answers: [3, 4, 3, 1, 4, 4, 5, 5, 5, 5],
      updatedAt: '2024-07-09 14:16:42',
    },
    {
      id: 73172,
      timeslotId: 171,
      type: LifemapType.work,
      activityName: 'GTM Bootcamp',
      answers: [3, 4, 3, 1, 4, 4, 5, 5, 5, 5],
      updatedAt: '2024-07-09 14:16:42',
    },
    {
      id: 74107,
      timeslotId: 172,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [4, 4, 3, 1, 3, 4, 4, 5, 5, 5],
      updatedAt: '2024-07-10 02:07:55',
    },
    {
      id: 74108,
      timeslotId: 173,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [4, 4, 3, 1, 3, 4, 4, 5, 5, 5],
      updatedAt: '2024-07-10 02:07:55',
    },
    {
      id: 74109,
      timeslotId: 174,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [4, 4, 3, 1, 3, 4, 4, 5, 5, 5],
      updatedAt: '2024-07-10 02:07:55',
    },
    {
      id: 74110,
      timeslotId: 175,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 1, 3, 4, 6, 6, 4, 4],
      updatedAt: '2024-07-10 02:08:29',
    },
    {
      id: 74111,
      timeslotId: 176,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 1, 3, 4, 6, 6, 4, 4],
      updatedAt: '2024-07-10 02:08:29',
    },
    {
      id: 74112,
      timeslotId: 177,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 1, 3, 4, 6, 6, 4, 4],
      updatedAt: '2024-07-10 02:08:29',
    },
    {
      id: 74113,
      timeslotId: 178,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 1, 3, 4, 6, 6, 4, 4],
      updatedAt: '2024-07-10 02:08:29',
    },
    {
      id: 74114,
      timeslotId: 179,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 1, 3, 4, 6, 6, 4, 4],
      updatedAt: '2024-07-10 02:08:29',
    },
    {
      id: 74115,
      timeslotId: 180,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 1, 3, 4, 6, 6, 4, 4],
      updatedAt: '2024-07-10 02:08:29',
    },
    {
      id: 74116,
      timeslotId: 181,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 1, 3, 4, 6, 6, 4, 4],
      updatedAt: '2024-07-10 02:08:29',
    },
    {
      id: 74117,
      timeslotId: 182,
      type: LifemapType.work,
      activityName: 'Onboarding',
      answers: [5, 4, 3, 1, 3, 4, 6, 6, 4, 4],
      updatedAt: '2024-07-10 02:08:29',
    },
    {
      id: 74118,
      timeslotId: 183,
      type: LifemapType.nonWork,
      activityName: 'Gym/Walk/Podcast',
      answers: [5, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-10 02:09:18',
    },
    {
      id: 74119,
      timeslotId: 184,
      type: LifemapType.nonWork,
      activityName: 'Gym/Walk/Podcast',
      answers: [5, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-10 02:09:18',
    },
    {
      id: 74120,
      timeslotId: 185,
      type: LifemapType.nonWork,
      activityName: 'Gym/Walk/Podcast',
      answers: [5, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-10 02:09:18',
    },
    {
      id: 74121,
      timeslotId: 186,
      type: LifemapType.nonWork,
      activityName: 'Gym/Walk/Podcast',
      answers: [5, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-10 02:09:18',
    },
    {
      id: 74122,
      timeslotId: 187,
      type: LifemapType.nonWork,
      activityName: 'Gym/Walk/Podcast',
      answers: [5, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-10 02:09:18',
    },
    {
      id: 74123,
      timeslotId: 188,
      type: LifemapType.nonWork,
      activityName: 'Gym/Walk/Podcast',
      answers: [5, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-10 02:09:18',
    },
    {
      id: 74124,
      timeslotId: 189,
      type: LifemapType.nonWork,
      activityName: 'Gym/Walk/Podcast',
      answers: [5, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-10 02:09:18',
    },
    {
      id: 74125,
      timeslotId: 190,
      type: LifemapType.nonWork,
      activityName: 'Gym/Walk/Podcast',
      answers: [5, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-10 02:09:18',
    },
    {
      id: 74126,
      timeslotId: 191,
      type: LifemapType.nonWork,
      activityName: 'Gym/Walk/Podcast',
      answers: [5, 5, 5, 5, 5, 5, 6, 6, 5, 5],
      updatedAt: '2024-07-10 02:09:18',
    },
    {
      id: 74947,
      timeslotId: 14,
      type: LifemapType.work,
      activityName: 'Slack',
      answers: [4, 3, 3, 1, 3, 3, 4, 6, 3, 4],
      updatedAt: '2024-07-10 10:49:05',
    },
    {
      id: 74948,
      timeslotId: 15,
      type: LifemapType.work,
      activityName: 'Slack',
      answers: [4, 3, 3, 1, 3, 3, 4, 6, 3, 4],
      updatedAt: '2024-07-10 10:49:05',
    },
    {
      id: 74949,
      timeslotId: 16,
      type: LifemapType.work,
      activityName: 'Zoom Recordings',
      answers: [3, 3, 3, 1, 3, 2, 3, 6, 3, 2],
      updatedAt: '2024-07-10 10:49:41',
    },
    {
      id: 74950,
      timeslotId: 17,
      type: LifemapType.work,
      activityName: 'Zoom Recordings',
      answers: [3, 3, 3, 1, 3, 2, 3, 6, 3, 2],
      updatedAt: '2024-07-10 10:49:41',
    },
    {
      id: 84950,
      timeslotId: 195,
      type: LifemapType.work,
      activityName: 'Zoom Recordings',
      answers: [3, 3, 3, 1, 3, 2, 3, 6, 3, 2],
      updatedAt: '2024-07-10 10:49:41',
    },
    {
      id: 94950,
      timeslotId: 196,
      type: LifemapType.work,
      activityName: 'Zoom Recordings',
      answers: [3, 3, 3, 1, 3, 2, 3, 6, 3, 2],
      updatedAt: '2024-07-10 10:49:41',
    },
  ];
};

export const getMockLifemapLogBug = (): LifemapLog[] => {
  return [
    {
      id: 4,
      timeslotId: 3,
      type: LifemapType.work,
      activityName: 'Night Shift',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-10-20 09:13:00',
    },
    {
      id: 5,
      timeslotId: 4,
      type: LifemapType.work,
      activityName: 'Night Shift',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-10-20 09:13:00',
    },
    {
      id: 6,
      timeslotId: 5,
      type: LifemapType.work,
      activityName: 'Night Shift',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-10-20 09:13:00',
    },
    {
      id: 7,
      timeslotId: 6,
      type: LifemapType.work,
      activityName: 'Night Shift',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-10-20 09:13:00',
    },
    {
      id: 13,
      timeslotId: 44,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-07 15:36:27',
    },
    {
      id: 17,
      timeslotId: 48,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-10-20 08:51:56',
    },
    {
      id: 18,
      timeslotId: 49,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-10-20 08:51:56',
    },
    {
      id: 19,
      timeslotId: 50,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-10-20 08:51:56',
    },
    {
      id: 20,
      timeslotId: 51,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-10-20 08:51:56',
    },
    {
      id: 21,
      timeslotId: 52,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-10-20 08:51:56',
    },
    {
      id: 22,
      timeslotId: 53,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-10-20 08:51:56',
    },
    {
      id: 38,
      timeslotId: 101,
      type: LifemapType.work,
      activityName: 'fesdd',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-21 15:08:26',
    },
    {
      id: 39,
      timeslotId: 102,
      type: LifemapType.work,
      activityName: 'fesdd',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-21 15:08:26',
    },
    {
      id: 40,
      timeslotId: 103,
      type: LifemapType.work,
      activityName: 'fesdd',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-21 15:08:26',
    },
    {
      id: 41,
      timeslotId: 104,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-21 15:05:55',
    },
    {
      id: 42,
      timeslotId: 105,
      type: LifemapType.work,
      activityName: 'fesdd',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-21 15:04:49',
    },
    {
      id: 43,
      timeslotId: 106,
      type: LifemapType.work,
      activityName: 'fesdd',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-21 15:04:49',
    },
    {
      id: 45,
      timeslotId: 140,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-21 15:04:30',
    },
    {
      id: 46,
      timeslotId: 141,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-21 15:04:30',
    },
    {
      id: 47,
      timeslotId: 142,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-21 15:04:30',
    },
    {
      id: 48,
      timeslotId: 143,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-21 15:04:30',
    },
    {
      id: 49,
      timeslotId: 144,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-21 15:04:35',
    },
    {
      id: 50,
      timeslotId: 145,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-21 15:04:35',
    },
    {
      id: 51,
      timeslotId: 146,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-21 15:04:35',
    },
    {
      id: 52,
      timeslotId: 147,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-21 15:04:35',
    },
    {
      id: 53,
      timeslotId: 148,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-21 15:04:35',
    },
    {
      id: 54,
      timeslotId: 149,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-21 15:04:35',
    },
    {
      id: 55,
      timeslotId: 150,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-21 15:04:35',
    },
    {
      id: 56,
      timeslotId: 151,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-21 15:04:35',
    },
    {
      id: 57,
      timeslotId: 152,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-10-20 08:51:57',
    },
    {
      id: 58,
      timeslotId: 153,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-10-20 08:51:57',
    },
    {
      id: 59,
      timeslotId: 154,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-10-20 08:51:57',
    },
    {
      id: 60,
      timeslotId: 155,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-10-20 08:51:57',
    },
    {
      id: 61,
      timeslotId: 188,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-10-20 08:51:57',
    },
    {
      id: 62,
      timeslotId: 189,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-10-20 08:51:57',
    },
    {
      id: 63,
      timeslotId: 190,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-10-20 08:51:57',
    },
    {
      id: 64,
      timeslotId: 191,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-10-20 08:51:57',
    },
    {
      id: 68,
      timeslotId: 15,
      type: LifemapType.work,
      activityName: 'dsa',
      answers: [1, 1, 2, 3, 4, 5, 5, 6, 4, 5],
      updatedAt: '2023-10-20 09:39:11',
    },
    {
      id: 70,
      timeslotId: 16,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-07 15:35:07',
    },
    {
      id: 71,
      timeslotId: 17,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-07 15:35:07',
    },
    {
      id: 72,
      timeslotId: 18,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-07 15:35:07',
    },
    {
      id: 73,
      timeslotId: 19,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-07 15:35:07',
    },
    {
      id: 75,
      timeslotId: 21,
      type: LifemapType.work,
      activityName: 'Lunch',
      answers: [1, 3, 3, 4, 5, 4, 3, 4, 5, 4],
      updatedAt: '2023-11-15 16:47:33',
    },
    {
      id: 76,
      timeslotId: 22,
      type: LifemapType.work,
      activityName: 'Lunch',
      answers: [1, 3, 3, 4, 5, 4, 3, 4, 5, 4],
      updatedAt: '2023-11-15 16:47:33',
    },
    {
      id: 77,
      timeslotId: 23,
      type: LifemapType.work,
      activityName: 'Lunch',
      answers: [1, 3, 3, 4, 5, 4, 3, 4, 5, 4],
      updatedAt: '2023-11-15 16:47:33',
    },
    {
      id: 78,
      timeslotId: 24,
      type: LifemapType.work,
      activityName: 'Lunch',
      answers: [1, 3, 3, 4, 5, 4, 3, 4, 5, 4],
      updatedAt: '2023-11-15 16:47:33',
    },
    {
      id: 79,
      timeslotId: 25,
      type: LifemapType.work,
      activityName: 'Lunch',
      answers: [1, 3, 3, 4, 5, 4, 3, 4, 5, 4],
      updatedAt: '2023-11-15 16:47:33',
    },
    {
      id: 80,
      timeslotId: 26,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-07 15:36:27',
    },
    {
      id: 81,
      timeslotId: 27,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-07 15:36:27',
    },
    {
      id: 82,
      timeslotId: 28,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-07 15:36:27',
    },
    {
      id: 83,
      timeslotId: 29,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-07 15:36:27',
    },
    {
      id: 84,
      timeslotId: 30,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-07 15:36:27',
    },
    {
      id: 85,
      timeslotId: 31,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-07 15:36:27',
    },
    {
      id: 86,
      timeslotId: 32,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-07 15:36:27',
    },
    {
      id: 87,
      timeslotId: 33,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-07 15:36:27',
    },
    {
      id: 88,
      timeslotId: 34,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-07 15:36:27',
    },
    {
      id: 89,
      timeslotId: 35,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-07 15:36:27',
    },
    {
      id: 90,
      timeslotId: 36,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-07 15:36:27',
    },
    {
      id: 91,
      timeslotId: 37,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-07 15:36:27',
    },
    {
      id: 92,
      timeslotId: 38,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-07 15:36:27',
    },
    {
      id: 93,
      timeslotId: 39,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-07 15:36:27',
    },
    {
      id: 94,
      timeslotId: 40,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-07 15:36:27',
    },
    {
      id: 95,
      timeslotId: 41,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-07 15:36:27',
    },
    {
      id: 96,
      timeslotId: 42,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-07 15:36:27',
    },
    {
      id: 97,
      timeslotId: 43,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-07 15:36:27',
    },
    {
      id: 98,
      timeslotId: 60,
      type: LifemapType.work,
      activityName: 'Something',
      answers: [1, 1, 1, 1, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-07 15:38:33',
    },
    {
      id: 99,
      timeslotId: 61,
      type: LifemapType.work,
      activityName: 'Something',
      answers: [1, 1, 1, 1, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-07 15:38:33',
    },
    {
      id: 104,
      timeslotId: 66,
      type: LifemapType.work,
      activityName: 'f',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-09 10:17:17',
    },
    {
      id: 105,
      timeslotId: 67,
      type: LifemapType.work,
      activityName: 'f',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-09 10:17:17',
    },
    {
      id: 106,
      timeslotId: 68,
      type: LifemapType.work,
      activityName: 'f',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-09 10:17:17',
    },
    {
      id: 107,
      timeslotId: 69,
      type: LifemapType.work,
      activityName: 'f',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-09 10:17:17',
    },
    {
      id: 108,
      timeslotId: 70,
      type: LifemapType.work,
      activityName: 'f',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-09 10:17:17',
    },
    {
      id: 109,
      timeslotId: 71,
      type: LifemapType.work,
      activityName: 'f',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-09 10:17:17',
    },
    {
      id: 110,
      timeslotId: 72,
      type: LifemapType.work,
      activityName: 'f',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-09 10:17:17',
    },
    {
      id: 111,
      timeslotId: 73,
      type: LifemapType.work,
      activityName: 'f',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-09 10:17:17',
    },
    {
      id: 112,
      timeslotId: 74,
      type: LifemapType.work,
      activityName: 'f',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-09 10:17:17',
    },
    {
      id: 113,
      timeslotId: 75,
      type: LifemapType.work,
      activityName: 'f',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-09 10:17:17',
    },
    {
      id: 121,
      timeslotId: 76,
      type: LifemapType.work,
      activityName: 'test',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-08 17:08:33',
    },
    {
      id: 122,
      timeslotId: 77,
      type: LifemapType.work,
      activityName: 'test',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-08 17:08:33',
    },
    {
      id: 123,
      timeslotId: 78,
      type: LifemapType.work,
      activityName: 'test',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-08 17:08:33',
    },
    {
      id: 124,
      timeslotId: 79,
      type: LifemapType.work,
      activityName: 'test',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-08 17:08:33',
    },
    {
      id: 125,
      timeslotId: 80,
      type: LifemapType.work,
      activityName: 'test',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-21 15:05:37',
    },
    {
      id: 126,
      timeslotId: 81,
      type: LifemapType.work,
      activityName: 'test',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-21 15:05:37',
    },
    {
      id: 127,
      timeslotId: 82,
      type: LifemapType.work,
      activityName: 'test',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-21 15:05:37',
    },
    {
      id: 128,
      timeslotId: 83,
      type: LifemapType.work,
      activityName: 'test',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-21 15:05:37',
    },
    {
      id: 129,
      timeslotId: 84,
      type: LifemapType.work,
      activityName: 'test',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-21 15:05:37',
    },
    {
      id: 130,
      timeslotId: 85,
      type: LifemapType.work,
      activityName: 'test',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-21 15:05:37',
    },
    {
      id: 139,
      timeslotId: 57,
      type: LifemapType.work,
      activityName: 'fdsfdssdf',
      answers: [6, 5, 5, 5, 5, 5, 5, 5, 5, 4],
      updatedAt: '2023-11-15 17:46:14',
    },
    {
      id: 140,
      timeslotId: 58,
      type: LifemapType.work,
      activityName: 'fdsfdssdf',
      answers: [6, 5, 5, 5, 5, 5, 5, 5, 5, 4],
      updatedAt: '2023-11-08 17:51:08',
    },
    {
      id: 141,
      timeslotId: 2,
      type: LifemapType.work,
      activityName: 'Night Shift',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-14 16:03:34',
    },
    {
      id: 142,
      timeslotId: 1,
      type: LifemapType.work,
      activityName: 'Night Shift',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-14 16:29:56',
    },
    {
      id: 143,
      timeslotId: 2,
      type: LifemapType.work,
      activityName: 'Night Shift',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-14 16:29:56',
    },
    {
      id: 149,
      timeslotId: 13,
      type: LifemapType.work,
      activityName: 'dsa',
      answers: [1, 1, 2, 3, 4, 5, 5, 6, 4, 5],
      updatedAt: '2023-11-15 14:00:09',
    },
    {
      id: 150,
      timeslotId: 14,
      type: LifemapType.work,
      activityName: 'dsa',
      answers: [1, 1, 2, 3, 4, 5, 5, 6, 4, 5],
      updatedAt: '2023-11-15 14:00:09',
    },
    {
      id: 153,
      timeslotId: 45,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-15 15:57:18',
    },
    {
      id: 154,
      timeslotId: 46,
      type: LifemapType.nonWork,
      activityName: 'Running',
      answers: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      updatedAt: '2023-11-15 15:57:18',
    },
    {
      id: 157,
      timeslotId: 62,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-15 16:32:52',
    },
    {
      id: 158,
      timeslotId: 63,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-15 16:32:52',
    },
    {
      id: 161,
      timeslotId: 59,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-15 16:32:56',
    },
    {
      id: 174,
      timeslotId: 120,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [1, 3, 4, 2, 1, 2, 3, 3, 2, 2],
      updatedAt: '2023-11-15 16:33:12',
    },
    {
      id: 175,
      timeslotId: 121,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [1, 3, 4, 2, 1, 2, 3, 3, 2, 2],
      updatedAt: '2023-11-15 16:33:12',
    },
    {
      id: 176,
      timeslotId: 122,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [1, 3, 4, 2, 1, 2, 3, 3, 2, 2],
      updatedAt: '2023-11-15 16:33:12',
    },
    {
      id: 177,
      timeslotId: 123,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [1, 3, 4, 2, 1, 2, 3, 3, 2, 2],
      updatedAt: '2023-11-15 16:33:12',
    },
    {
      id: 178,
      timeslotId: 124,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [1, 3, 4, 2, 1, 2, 3, 3, 2, 2],
      updatedAt: '2023-11-15 16:33:12',
    },
    {
      id: 179,
      timeslotId: 125,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [1, 3, 4, 2, 1, 2, 3, 3, 2, 2],
      updatedAt: '2023-11-15 16:33:12',
    },
    {
      id: 180,
      timeslotId: 126,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [1, 3, 4, 2, 1, 2, 3, 3, 2, 2],
      updatedAt: '2023-11-15 16:33:12',
    },
    {
      id: 181,
      timeslotId: 127,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [1, 3, 4, 2, 1, 2, 3, 3, 2, 2],
      updatedAt: '2023-11-15 16:33:12',
    },
    {
      id: 182,
      timeslotId: 128,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [1, 3, 4, 2, 1, 2, 3, 3, 2, 2],
      updatedAt: '2023-11-15 16:33:12',
    },
    {
      id: 185,
      timeslotId: 131,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-15 16:33:29',
    },
    {
      id: 186,
      timeslotId: 132,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-15 16:33:29',
    },
    {
      id: 187,
      timeslotId: 133,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-15 16:33:29',
    },
    {
      id: 188,
      timeslotId: 134,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-15 16:33:29',
    },
    {
      id: 189,
      timeslotId: 135,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-15 16:33:29',
    },
    {
      id: 190,
      timeslotId: 136,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-15 16:33:29',
    },
    {
      id: 191,
      timeslotId: 137,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-15 16:33:30',
    },
    {
      id: 192,
      timeslotId: 138,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-15 16:33:30',
    },
    {
      id: 193,
      timeslotId: 139,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-15 16:33:30',
    },
    {
      id: 200,
      timeslotId: 162,
      type: LifemapType.nonWork,
      activityName: 'fdfsdfds',
      answers: [1, 2, 1, 2, 1, 1, 1, 1, 1, 2],
      updatedAt: '2023-11-21 14:43:06',
    },
    {
      id: 201,
      timeslotId: 163,
      type: LifemapType.nonWork,
      activityName: 'fdfsdfds',
      answers: [1, 2, 1, 2, 1, 1, 1, 1, 1, 2],
      updatedAt: '2023-11-21 14:43:06',
    },
    {
      id: 202,
      timeslotId: 164,
      type: LifemapType.nonWork,
      activityName: 'fdfsdfds',
      answers: [1, 2, 1, 2, 1, 1, 1, 1, 1, 2],
      updatedAt: '2023-11-21 14:43:06',
    },
    {
      id: 203,
      timeslotId: 165,
      type: LifemapType.nonWork,
      activityName: 'fdfsdfds',
      answers: [1, 2, 1, 2, 1, 1, 1, 1, 1, 2],
      updatedAt: '2023-11-21 14:43:06',
    },
    {
      id: 204,
      timeslotId: 166,
      type: LifemapType.nonWork,
      activityName: 'fdfsdfds',
      answers: [1, 2, 1, 2, 1, 1, 1, 1, 1, 2],
      updatedAt: '2023-11-21 14:43:06',
    },
    {
      id: 205,
      timeslotId: 167,
      type: LifemapType.nonWork,
      activityName: 'fdfsdfds',
      answers: [1, 2, 1, 2, 1, 1, 1, 1, 1, 2],
      updatedAt: '2023-11-21 14:43:06',
    },
    {
      id: 206,
      timeslotId: 168,
      type: LifemapType.nonWork,
      activityName: 'fdfsdfds',
      answers: [1, 2, 1, 2, 1, 1, 1, 1, 1, 2],
      updatedAt: '2023-11-21 14:43:06',
    },
    {
      id: 221,
      timeslotId: 183,
      type: LifemapType.work,
      activityName: 'Brainstorming the end of the year',
      answers: [1, 5, 3, 5, 2, 1, 4, 5, 2, 4],
      updatedAt: '2023-11-15 16:34:17',
    },
    {
      id: 222,
      timeslotId: 184,
      type: LifemapType.work,
      activityName: 'Brainstorming the end of the year',
      answers: [1, 5, 3, 5, 2, 1, 4, 5, 2, 4],
      updatedAt: '2023-11-15 16:34:17',
    },
    {
      id: 223,
      timeslotId: 185,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-15 16:45:57',
    },
    {
      id: 224,
      timeslotId: 186,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-15 16:39:07',
    },
    {
      id: 225,
      timeslotId: 187,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-15 16:34:48',
    },
    {
      id: 227,
      timeslotId: 20,
      type: LifemapType.work,
      activityName: 'Lunch',
      answers: [1, 3, 3, 4, 5, 4, 3, 4, 5, 4],
      updatedAt: '2023-11-15 17:00:15',
    },
    {
      id: 228,
      timeslotId: 129,
      type: LifemapType.work,
      activityName: 'Meeting',
      answers: [1, 3, 4, 2, 1, 2, 3, 3, 2, 2],
      updatedAt: '2023-11-15 17:14:32',
    },
    {
      id: 229,
      timeslotId: 130,
      type: LifemapType.nonWork,
      activityName: 'Pub with friends',
      answers: [1, 1, 2, 2, 2, 2, 2, 2, 2, 2],
      updatedAt: '2023-11-15 17:14:40',
    },
    {
      id: 232,
      timeslotId: 64,
      type: LifemapType.work,
      activityName: 'f',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-15 17:18:59',
    },
    {
      id: 233,
      timeslotId: 65,
      type: LifemapType.work,
      activityName: 'f',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-15 17:18:59',
    },
    {
      id: 248,
      timeslotId: 7,
      type: LifemapType.work,
      activityName: 'Night Shift',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-17 09:02:11',
    },
    {
      id: 249,
      timeslotId: 8,
      type: LifemapType.work,
      activityName: 'Night Shift',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-17 09:03:34',
    },
    {
      id: 251,
      timeslotId: 156,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-17 09:29:28',
    },
    {
      id: 252,
      timeslotId: 157,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-17 09:29:28',
    },
    {
      id: 253,
      timeslotId: 54,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-17 09:29:32',
    },
    {
      id: 254,
      timeslotId: 55,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-17 09:29:32',
    },
    {
      id: 255,
      timeslotId: 56,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-17 09:29:32',
    },
    {
      id: 256,
      timeslotId: 9,
      type: LifemapType.work,
      activityName: 'dsa',
      answers: [1, 1, 2, 3, 4, 5, 5, 6, 4, 5],
      updatedAt: '2023-11-17 09:29:34',
    },
    {
      id: 257,
      timeslotId: 10,
      type: LifemapType.work,
      activityName: 'dsa',
      answers: [1, 1, 2, 3, 4, 5, 5, 6, 4, 5],
      updatedAt: '2023-11-17 09:29:34',
    },
    {
      id: 258,
      timeslotId: 11,
      type: LifemapType.work,
      activityName: 'dsa',
      answers: [1, 1, 2, 3, 4, 5, 5, 6, 4, 5],
      updatedAt: '2023-11-17 09:29:34',
    },
    {
      id: 259,
      timeslotId: 12,
      type: LifemapType.work,
      activityName: 'dsa',
      answers: [1, 1, 2, 3, 4, 5, 5, 6, 4, 5],
      updatedAt: '2023-11-17 09:29:34',
    },
    {
      id: 262,
      timeslotId: 114,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-21 14:58:28',
    },
    {
      id: 263,
      timeslotId: 115,
      type: LifemapType.work,
      activityName: 'fdsfdsfds',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-17 09:29:38',
    },
    {
      id: 264,
      timeslotId: 116,
      type: LifemapType.work,
      activityName: 'fdsfdsfds',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-17 09:29:38',
    },
    {
      id: 265,
      timeslotId: 117,
      type: LifemapType.work,
      activityName: 'fdsfdsfds',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-17 09:29:38',
    },
    {
      id: 266,
      timeslotId: 118,
      type: LifemapType.work,
      activityName: 'fdsfdsfds',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-17 09:29:38',
    },
    {
      id: 267,
      timeslotId: 119,
      type: LifemapType.work,
      activityName: 'fdsfdsfds',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-17 09:29:38',
    },
    {
      id: 271,
      timeslotId: 174,
      type: LifemapType.work,
      activityName: 'Brainstorming the end of the year',
      answers: [1, 5, 3, 5, 2, 1, 4, 5, 2, 4],
      updatedAt: '2023-11-17 09:29:41',
    },
    {
      id: 272,
      timeslotId: 175,
      type: LifemapType.work,
      activityName: 'Brainstorming the end of the year',
      answers: [1, 5, 3, 5, 2, 1, 4, 5, 2, 4],
      updatedAt: '2023-11-17 09:29:41',
    },
    {
      id: 273,
      timeslotId: 176,
      type: LifemapType.work,
      activityName: 'Brainstorming the end of the year',
      answers: [1, 5, 3, 5, 2, 1, 4, 5, 2, 4],
      updatedAt: '2023-11-17 09:29:41',
    },
    {
      id: 274,
      timeslotId: 177,
      type: LifemapType.work,
      activityName: 'Brainstorming the end of the year',
      answers: [1, 5, 3, 5, 2, 1, 4, 5, 2, 4],
      updatedAt: '2023-11-17 09:29:41',
    },
    {
      id: 275,
      timeslotId: 178,
      type: LifemapType.work,
      activityName: 'Brainstorming the end of the year',
      answers: [1, 5, 3, 5, 2, 1, 4, 5, 2, 4],
      updatedAt: '2023-11-17 09:29:41',
    },
    {
      id: 276,
      timeslotId: 179,
      type: LifemapType.work,
      activityName: 'Brainstorming the end of the year',
      answers: [1, 5, 3, 5, 2, 1, 4, 5, 2, 4],
      updatedAt: '2023-11-17 09:29:41',
    },
    {
      id: 277,
      timeslotId: 180,
      type: LifemapType.work,
      activityName: 'Brainstorming the end of the year',
      answers: [1, 5, 3, 5, 2, 1, 4, 5, 2, 4],
      updatedAt: '2023-11-17 09:29:41',
    },
    {
      id: 278,
      timeslotId: 181,
      type: LifemapType.work,
      activityName: 'Brainstorming the end of the year',
      answers: [1, 5, 3, 5, 2, 1, 4, 5, 2, 4],
      updatedAt: '2023-11-17 09:29:41',
    },
    {
      id: 279,
      timeslotId: 182,
      type: LifemapType.work,
      activityName: 'Brainstorming the end of the year',
      answers: [1, 5, 3, 5, 2, 1, 4, 5, 2, 4],
      updatedAt: '2023-11-17 09:29:41',
    },
    {
      id: 282,
      timeslotId: 173,
      type: LifemapType.work,
      activityName: 'Brainstorming the end of the year',
      answers: [1, 5, 3, 5, 2, 1, 4, 5, 2, 4],
      updatedAt: '2023-11-17 10:56:29',
    },
    {
      id: 283,
      timeslotId: 169,
      type: LifemapType.nonWork,
      activityName: 'fdfsdfds',
      answers: [1, 2, 1, 2, 1, 1, 1, 1, 1, 2],
      updatedAt: '2023-11-21 14:43:06',
    },
    {
      id: 285,
      timeslotId: 0,
      type: LifemapType.work,
      activityName: 'Night Shift',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-17 12:03:24',
    },
    {
      id: 287,
      timeslotId: 170,
      type: LifemapType.nonWork,
      activityName: 'fdfsdfds',
      answers: [1, 2, 1, 2, 1, 1, 1, 1, 1, 2],
      updatedAt: '2023-11-21 14:43:06',
    },
    {
      id: 288,
      timeslotId: 171,
      type: LifemapType.nonWork,
      activityName: 'fdfsdfds',
      answers: [1, 2, 1, 2, 1, 1, 1, 1, 1, 2],
      updatedAt: '2023-11-21 14:43:06',
    },
    {
      id: 291,
      timeslotId: 107,
      type: LifemapType.work,
      activityName: 'fesdd',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-21 15:04:49',
    },
    {
      id: 292,
      timeslotId: 108,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-21 14:58:28',
    },
    {
      id: 293,
      timeslotId: 109,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-21 14:58:28',
    },
    {
      id: 294,
      timeslotId: 110,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-21 14:58:28',
    },
    {
      id: 295,
      timeslotId: 111,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-21 14:58:28',
    },
    {
      id: 296,
      timeslotId: 112,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-21 14:58:28',
    },
    {
      id: 297,
      timeslotId: 113,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-21 14:58:28',
    },
    {
      id: 298,
      timeslotId: 172,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-21 15:03:49',
    },
    {
      id: 299,
      timeslotId: 158,
      type: LifemapType.work,
      activityName: 'gfddgfd',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-21 15:04:02',
    },
    {
      id: 300,
      timeslotId: 159,
      type: LifemapType.work,
      activityName: 'gfddgfd',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-21 15:04:02',
    },
    {
      id: 309,
      timeslotId: 94,
      type: LifemapType.work,
      activityName: 'fesdd',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-21 15:08:10',
    },
    {
      id: 310,
      timeslotId: 95,
      type: LifemapType.work,
      activityName: 'fesdd',
      answers: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      updatedAt: '2023-11-21 15:08:10',
    },
    {
      id: 313,
      timeslotId: 98,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-21 15:08:29',
    },
    {
      id: 314,
      timeslotId: 99,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-21 15:08:29',
    },
    {
      id: 315,
      timeslotId: 100,
      type: LifemapType.sleep,
      activityName: 'Sleep',
      answers: [null, null, null, null, null, null, null, null, null, null],
      updatedAt: '2023-11-21 15:08:29',
    },
  ];
};
